/**
 * @function    isArray
 * @description check of instance on type of array
 * @param       val {any}
 * @returns     {boolean}
 */
export function isArray(val) {
  return toString.call(val) === '[object Array]'
}

/**
 * @function    isObject
 * @description check of instance on type of object
 * @param       val {any}
 * @returns     {boolean}
 */
export function isObject(val) {
  return val !== null && typeof val === 'object'
}

/**
 * @function    arrayToMethod
 * @description conversion keys of array nesting objects from snake/camel notation to camel/snake notation
 * @param       array {array} - handling object;
 * @param       method {function} - handle nesting object function.
 * @returns     {array}
 */
function arrayToMethod(array, method) {
  return array.reduce((acc, item) => {
    acc.push(isObject(item) ? method(item) : item)
    return acc
  }, [])
}

/**
 * @function    snakeToCamel
 * @description conversion object keys(and nesting) from snake notation to camel notation
 * @param       obj {object} - handling object.
 * @returns     {object}
 */
export function snakeToCamel(obj) {
  //console.log("snakeToCamel")
  //console.log(obj)
  if (isObject(obj)) {
    if (isArray(obj)) return arrayToMethod(obj, snakeToCamel)
    return Object.keys(obj).reduce((acc, snakeKey) => {
      const camelKey = snakeKey.replace(/_\w/g, matches => matches[1].toUpperCase())
      acc[camelKey] = isObject(obj[snakeKey]) ? snakeToCamel(obj[snakeKey]) : obj[snakeKey]
      return acc
    }, {})
  }
}

/**
 * @function    camelToSnake
 * @description conversion object keys(and nesting) from camel notation to snake notation
 * @param       obj {object} - handling object.
 * @returns     {object}
 */
export function camelToSnake(obj) {
  if (isObject(obj)) {
    if (isArray(obj)) return arrayToMethod(obj, camelToSnake)
    return Object.keys(obj).reduce((acc, camelKey) => {
      const snakeKey = camelKey.replace(/([A-Z])/g, matches => `_${matches[0].toLowerCase()}`)
      acc[snakeKey] = isObject(obj[camelKey]) ? camelToSnake(obj[camelKey]) : obj[camelKey]
      return acc
    }, {})
  }
}
